import { render, staticRenderFns } from "./MatrixSummary.vue?vue&type=template&id=681d50e0&scoped=true"
import script from "./MatrixSummary.vue?vue&type=script&lang=js"
export * from "./MatrixSummary.vue?vue&type=script&lang=js"
import style0 from "./MatrixSummary.vue?vue&type=style&index=0&id=681d50e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d50e0",
  null
  
)

export default component.exports